import { useTranslation } from "react-i18next";

import styles from "./Greeting.module.scss";

interface IProps {
    greetM: string;
    greetL: string;
}

const Greeting = ({ greetM, greetL }: IProps) => {
    const { t } = useTranslation();
    return (
        <div className={styles.greeting}>
            <div className={styles.hello}>{greetM ? `${t(greetM)}` : "hello"}</div>
            <div className={styles.welcome}>{greetL ? `${t(greetL)}` : "welcome"}</div>
        </div>
    );
};
export default Greeting;
